export const TERMS_CONTENT_DEFAULT = `תנאי השימוש מנוסחים בלשון זכר לצרכי נוחות בלבד, אך הם מתייחסים לגברים ולנשים כאחד.

1. מבוא
1.1. אתר Excess Market (להלן: "האתר") מופעל ומנוהל על ידי חברת Excess Market או מי מטעמה (להלן: "החברה").
1.2. הגלישה והשימוש באתר, לרבות רכישת מוצרים דרך האתר, כפופים לתנאים המפורטים במסמך זה (להלן: "תנאי השימוש"). שימושך באתר מהווה הסכמה לכל התנאים הללו.
1.3. אם אינך מסכים לאחד או יותר מהתנאים – הנך מתבקש להימנע מלעשות שימוש באתר.

2. השירותים המוצעים באתר
2.1. האתר משמש כפלטפורמה לפרסום, שיווק ומכירת מוצרים עודפים (חומרי בנייה, עיצוב ועוד) מטעם ספקים שונים.
2.2. המוצרים המוצעים באתר עשויים להיות "כפי שהם" (as-is), עודפים, ללא אחריות יצרן, ובכמות מוגבלת.
2.3. החברה שומרת לעצמה את הזכות להוסיף, לשנות, להפסיק או לעדכן את השירותים באתר בכל עת, ללא צורך במתן הודעה מוקדמת.

3. הרשמה ורכישה
3.1. לצורך רכישת מוצרים באתר יש להירשם ולספק פרטים מדויקים, עדכניים ומלאים.
3.2. המשתמש אחראי על שמירת סודיות פרטי ההתחברות שלו.
3.3. החברה רשאית, לפי שיקול דעתה, לא לאשר רישום של משתמש, לבטל רכישה או לחסום גישה במקרים של הפרת תנאים.

4. מחירים ותשלומים
4.1. כל המחירים באתר כוללים מע"מ אלא אם צוין אחרת.
4.2. התשלום יתבצע באמצעות אמצעי התשלום המאושרים באתר (כגון כרטיס אשראי, העברה בנקאית, סליקה מאובטחת).
4.3. החברה שומרת לעצמה את הזכות לשנות את מחירי המוצרים באתר בכל עת, אולם שינוי כאמור לא ישפיע על הזמנות שבוצעו קודם לכן.

5. אספקה ומשלוחים
5.1. זמני האספקה והמשלוח מפורטים בכל עמוד מוצר, וייתכנו שינויים לפי זמינות, מיקום גיאוגרפי של הלקוח ואופי המוצר.
5.2. יתכנו מוצרים אשר אינם כוללים משלוח, ודורשים איסוף עצמי ממחסן הספק. תנאי האיסוף והאחריות חלים על הלקוח.

6. החזרות וביטולים - מדיניות לפי דירוג מוצר
6.1. דירוג A (פרימיום)
מוצרים במצב מושלם, ניתן להחזירם בתוך 14 יום מיום הקבלה במצב סגור ובאריזה המקורית. החזר מלא בניכוי דמי משלוח.

6.2. דירוג B (סטנדרט)
מוצרים במצב טוב, ניתן להחזירם בתוך 7 ימים מיום הקבלה במצב סגור ובאריזה המקורית. החזר בניכוי 10% דמי טיפול ודמי משלוח.

6.3. דירוג C (כפי שהוא)
מוצרים נמכרים במצבם הנוכחי, ללא אפשרות להחזרה אלא במקרה של פגם מהותי שלא צוין בתיאור המוצר.

6.4. דירוג D (מכירה סופית)
מוצרים במחירי מבצע סופיים, ללא אפשרות להחזרה או החלפה בכל מקרה.

6.5. חריגות יתבצעו לפי שיקול דעת החברה ובהתאם לחוק הגנת הצרכן, התשמ"א-1981.
6.6. במקרה של ביטול עסקה שאושר, ההחזר יבוצע בהתאם לאמצעי התשלום המקורי, בניכוי עלויות משלוח ודמי טיפול המפורטים לעיל.

7. אחריות והגבלת אחריות
7.1. החברה אינה היצרנית של המוצרים, ולפיכך אינה אחראית לטיבם, התאמתם, עמידותם או כל פגם שיתגלה בהם לאחר הרכישה.
7.2. כל המידע באתר מוצג "כפי שהוא" (as-is), ואין לראות בו ייעוץ מקצועי או התחייבות לתוצאה כלשהי.
7.3. החברה לא תישא באחריות לנזק עקיף או ישיר שייגרם למשתמש או לצד ג' עקב שימוש באתר או במוצריו.

8. קניין רוחני
8.1. כל התכנים, התמונות, המידע, הקוד והעיצוב באתר הם רכוש החברה או הצדדים השלישיים שהרשו את השימוש בהם.
8.2. אין להעתיק, לשכפל, לפרסם או לעשות שימוש מסחרי כלשהו בתכני האתר ללא אישור מראש ובכתב מהחברה.

9. פרטיות ואבטחת מידע
9.1. מדיניות הפרטיות של האתר מהווה חלק בלתי נפרד מתנאי השימוש וניתן לעיין בה כאן.
9.2. החברה מתחייבת לשמור על סודיות המידע שתמסור במהלך השימוש, בהתאם למדיניות הפרטיות וחוק הגנת הפרטיות.

10. שינויים בתנאי השימוש
10.1. החברה רשאית לעדכן את תנאי השימוש בכל עת, לפי שיקול דעתה הבלעדי.
10.2. תוקף התנאים החדשים יהיה מרגע פרסומם באתר, ומומלץ להתעדכן מעת לעת.

11. סמכות שיפוט
11.1. על השימוש באתר יחולו אך ורק דיני מדינת ישראל.
11.2. כל מחלוקת שתתעורר בקשר לשימוש באתר תתברר בבתי המשפט המוסמכים במחוז תל אביב בלבד.`;

export const PRIVACY_CONTENT_DEFAULT = `Excess Market (להלן: "החברה", "אנחנו", "שלנו") מכבדת את פרטיות המשתמשים באתר האינטרנט שלה (להלן: "האתר").
מדיניות פרטיות זו נועדה להסביר אילו נתונים נאספים עליך, כיצד אנו משתמשים בהם, ובאילו נסיבות אנו משתפים אותם עם צדדים שלישיים.

1. מידע שנאסף
בעת השימוש באתר, ייתכן וייאסף עליך מידע מהסוגים הבאים:
1.1. מידע אישי שאתה מספק:
* שם מלא
* מספר טלפון
* כתובת דוא"ל
* כתובת למשלוח
* פרטי תשלום (באמצעות ספק סליקה בלבד)
* כל פרט שתמסור באופן יזום בעת ההרשמה, רכישה, פנייה לשירות לקוחות או שימוש בטופס יצירת קשר.

1.2. מידע טכני:
* כתובת IP
* סוג דפדפן ומערכת הפעלה
* עמודים שנצפו, משך זמן שהות באתר, ואינטראקציות שונות
* Cookies וטכנולוגיות דומות

2. מטרות השימוש במידע
אנו משתמשים במידע שנאסף לצרכים הבאים:
* תפעול וניהול תקין של האתר
* מתן שירותים (כולל עיבוד הזמנות, שילוח, שירות לקוחות)
* יצירת קשר עם המשתמש במקרה הצורך
* אבטחת מידע ומניעת הונאות
* שיפור חוויית המשתמש והתאמה אישית של תכנים
* שליחת עדכונים, מבצעים ופרסומות – רק בכפוף להסכמתך (opt-in)

3. מסירת מידע לצדדים שלישיים
איננו מוכרים, משכירים או מעבירים את פרטיך האישיים לצדדים שלישיים, למעט במקרים הבאים:
* לצורך אספקת השירותים באתר (כגון חברות סליקה, שילוח, שירותי אחסון)
* אם נדרש על פי דין או צו שיפוטי
* במקרה של מיזוג, רכישה או מכירת פעילות העסק – בכפוף להתחייבות הצד הרוכש לשמור על תנאי פרטיות זהים
* במקרה של הפרת תנאי השימוש או ביצוע פעולה אסורה על פי חוק

4. אבטחת מידע
החברה עושה מאמצים סבירים ומקובלים לאבטחת המידע באתר, כולל שימוש בפרוטוקול SSL, הצפנת נתונים, ואמצעי הגנה נוספים.
עם זאת, אין ביכולתנו להבטיח אבטחה מוחלטת של המידע, ומשתמש נדרש לנקוט אמצעי זהירות אישיים (כגון שמירה על סיסמה).

5. שימוש בעוגיות (Cookies)
האתר משתמש בקבצי cookies כדי לזהות משתמשים חוזרים, לשפר את חוויית השימוש ולבצע מדידות וניתוחים סטטיסטיים.
באפשרותך להגדיר את הדפדפן לחסום עוגיות, אך ייתכן שחלק מהפונקציות באתר לא יעבדו כראוי.

6. גישה, תיקון ומחיקה
בהתאם לחוק הגנת הפרטיות, כל אדם זכאי לעיין במידע שנשמר עליו. אם ברצונך לעיין, לתקן או למחוק את המידע – ניתן לפנות אלינו בכתב לכתובת: info@excess-market.co.il.

7. קטינים
השימוש באתר אינו מיועד למשתמשים מתחת לגיל 18. אם אתה קטין – עליך לקבל אישור מהורה או אפוטרופוס חוקי לפני השימוש באתר.

8. שינויים במדיניות הפרטיות
אנו רשאים לשנות את מדיניות הפרטיות מעת לעת. עדכונים מהותיים יתפרסמו באתר, ותאריך העדכון האחרון יצוין בראש המסמך.`;

export const ACCESSIBILITY_CONTENT_DEFAULT = `על פי תיקון לתקנות העוסקות בנגישות האינטרנט אתר זה פטור מחובת נגישות, אך אף על פי כן עושה מאמצים לאפשר נגישות מירבית ומאפשר ממשק נגישות מתקדם המופעל באמצעות כפתור המופיע דרך קבע בצד שמאל של האתר.

בלחיצה על הכפתור ניתן להפעיל רכיבים כגון:
ניווט מקלדת
פונט קריא
קו תחתון בקישורים
סימון קישורים עם צבע רקע
ניקוי זכרון "עוגיות" (Cookies)
תמונות באפור
היפוך צבעים
הסרת אנימציות
הסרת עיצוב (CSS)
ועוד

בנוסף, האתר הונגש באופן הבא:
האתר מותאם לכל סוגי הדפדפנים המודרניים.
האתר מותאים לכל סוגי הפלטפורמות – מובייל, טאבלט ודסקטופ.
האתר מותאם מבחינת שימוש במקלדת בלבד.
כל התמונות באתר מכילות טקסט חליפי (ALT).
ייתכן ותמצאו אלמנטים שאינם מונגשים כי טרם הונגשו או שלא נמצאה טכנולוגיה מתאימה ולצד זה אנו מבטיחים כי מתבצעים מרב המאמצים לשפר ולהנגיש ברמה גבוהה ובלי פשרות.

במידה ובכל זאת אותרו בעיות נגישות, נשמח אם יפנו אלינו ישירות עם פירוט הליקויים הנדרשים לתיקון, באמצעות אחד הערוצים: טופס צור קשר, או מייל: info@a.co.il. ט.ל.ח.`;
